"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEEP_MATTING_SMALLER_EDGE_PROPORTION = exports.MATTING_TO_BORDER_WIDTH = exports.MASK_MATTING = exports.SUPPORTED_MATTING = exports.MATTING = exports.MAT_COLORS = exports.DEFAULT_MAT_COLOR = void 0;
const artConsts_1 = require("./artConsts");
const tiles_1 = require("./tiles");
exports.DEFAULT_MAT_COLOR = 'WHITE';
var MAT_COLORS;
(function (MAT_COLORS) {
    MAT_COLORS["WHITE"] = "#FFFFFF";
    MAT_COLORS["LIGHT_BROWN"] = "#F9ECDD";
    MAT_COLORS["LIGHT_RED"] = "#F5E3E2";
    MAT_COLORS["LIGHT_BLUE"] = "#D3E8FE";
    MAT_COLORS["LIGHT_TURQUOISE"] = "#C5DAD9";
    MAT_COLORS["DARK_BROWN"] = "#9D8974";
    MAT_COLORS["DARK_RED"] = "#D5747F";
    MAT_COLORS["DARK_BLUE"] = "#5B789E";
    MAT_COLORS["DARK_TURQUOISE"] = "#7DA3A1";
    MAT_COLORS["NONE"] = "NONE";
})(MAT_COLORS = exports.MAT_COLORS || (exports.MAT_COLORS = {}));
var MATTING;
(function (MATTING) {
    MATTING["NONE"] = "none";
    MATTING["DEEP"] = "deep";
    MATTING["ULTRA_DEEP"] = "ultraDeep";
    MATTING["MEDIUM"] = "medium";
    MATTING["SHALLOW"] = "shallow";
    MATTING["TOP"] = "top";
    MATTING["ROUND"] = "round";
    MATTING["HEART"] = "heart";
})(MATTING = exports.MATTING || (exports.MATTING = {}));
exports.SUPPORTED_MATTING = [MATTING.NONE, MATTING.SHALLOW, MATTING.MEDIUM, MATTING.DEEP];
exports.MASK_MATTING = {
    ROUND: 'round',
    HEART: 'heart',
};
exports.MATTING_TO_BORDER_WIDTH = {
    [MATTING.DEEP]: {
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 25,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 25,
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 28,
        [tiles_1.TILE_SIZES.RECTANGLE_22X44]: 28,
        [tiles_1.TILE_SIZES.RECTANGLE_44X22]: 28,
    },
    [MATTING.ULTRA_DEEP]: {
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 32,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 32,
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 36,
    },
    [MATTING.TOP]: {
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 15,
    },
    [MATTING.ROUND]: {
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 17,
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 17,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 17,
    },
    [MATTING.HEART]: {
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 17,
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 15,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 15,
    },
    [MATTING.MEDIUM]: {
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 20,
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 20,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 20,
    },
    [MATTING.SHALLOW]: {
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 10,
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 10,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 10,
    },
    [MATTING.NONE]: {
        [artConsts_1.PHOTO_ORIENTATIONS.SQUARE]: 0,
        [artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT]: 0,
        [artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE]: 0,
    },
};
exports.DEEP_MATTING_SMALLER_EDGE_PROPORTION = 0.8;
//# sourceMappingURL=matting.js.map